import styled, { css } from 'styled-components';
import { Card, Collapsible } from '@equifinance/shared';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import Page from '../components/Page';
import { useAccountContext } from '../contexts';
import { Segment } from '../contexts/account/IncomeAndEmployment';

export const Container = styled(Card)`${({ theme }) => `
  width: 100%;
  margin-left: ${theme.padding[8]};
  margin-right: ${theme.padding[8]};
  background: ${theme.colours.neutral[10]};
  color: ${theme.textPrimary};
  border-radius:${theme.padding[3]};
  padding: 0 ${theme.padding[11]} ${theme.padding[5]} ${theme.padding[11]};
  box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  color: ${theme.textPrimary};
`}`;

const headerCss = css`${({ theme }) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.padding[2]};
  height: 108px;
  background: ${theme.colours.neutral[10]};
  border-radius: 0;
  border-bottom: ${theme.borderWidth[1]} solid ${theme.colours.neutral[4]};
  padding: 0;
  
  div, i {
    font-size: ${theme.fontSize[7]};
    font-weight: ${theme.fontWeight.bold};
    line-height: ${theme.fontSize[9]};
    color: ${theme.colours.neutral[2]};
  }
`}`;

const bodyCss = css`${({ theme }) => `
  background: ${theme.colours.neutral[9]};
  padding: ${theme.padding[3]} ${theme.padding[9]};
  border-radius: 0px 0px ${theme.padding[4]} ${theme.padding[4]};
  font-size: ${theme.fontSize[4]};
  line-height: ${theme.fontSize[8]};
`}`;

export default function IncomeAndEmploymentInfo() {
  const { account } = useAccountContext();
  const { applicantId } = useParams();

  const segments = useMemo(() => {
    const applicant = account.applicants.find((applicant) => applicant.id === applicantId);
    if (applicant) {
      return applicant.incomeAndEmployment.versionInfo || [];
    }
    return [];
  }, [account, applicantId]);

  return (
    <Page>
      <Container>
        {segments.map(({ segment }) => (
          <Collapsible
            id={segment}
            key={segment}
            headerCss={headerCss}
            bodyCss={bodyCss}
            level={2}
            title={Segment[segment]}
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean lobortis arcu quis dignissim iaculis.
          </Collapsible>
        ))}
      </Container>
    </Page>
  );
}
